export default "__VITE_ASSET__cdb72ba6__"